import Text, { TEXT_VARIANT_STYLES } from "shared/components/data-display/text/Text";
import { COLOR_VALUES } from "shared/config/colors";
import { SPACING_VALUES } from "shared/config/spacing";
import styled, { css } from "styled-components";

export const SegmentedWrapper = styled.div`
    display: inline-flex;
    gap: 1px;
    background: ${COLOR_VALUES.Gray_6};
    border: 1px solid ${COLOR_VALUES.Gray_6};
    border-radius: 4px;
    height: fit-content;
    width: fit-content;
    overflow: hidden;
`;

export const SegmentedButton = styled.button`
    border: 0;
    margin: 0;
    padding: ${SPACING_VALUES.Zero_5} ${SPACING_VALUES.One};

    &[aria-pressed="false"] {
        background: ${COLOR_VALUES.Gray_9};
        color: ${COLOR_VALUES.Gray_2};
        ${TEXT_VARIANT_STYLES.Body_2_1};

        &:not(:disabled) {
            cursor: pointer;

            &:hover {
                color: ${COLOR_VALUES.Gray_4};
            }

            &:active {
                background: ${COLOR_VALUES.White};
                color: ${COLOR_VALUES.Black};
            }
        }

        &:disabled {
            cursor: not-allowed;
        }
    }

    &[aria-pressed="true"] {
        background: ${COLOR_VALUES.White};
        box-shadow: 0 0 0 1px ${COLOR_VALUES.Gray_5};
        ${TEXT_VARIANT_STYLES.Body_2_2};

        &:not(:disabled) {
            cursor: auto;
            color: ${COLOR_VALUES.Black};
        }

        &:disabled {
            cursor: not-allowed;
            color: ${COLOR_VALUES.Gray_2};
        }
    }
`;

export const StyledText = styled(Text)`
    color: ${COLOR_VALUES.Gray_1};
    ${(props) =>
        props.isDisabled &&
        css`
            color: ${COLOR_VALUES.Gray_3};
        `}
`;
